<template>
  <div id="app" class="app">
    <Header/>
    <router-view/>
  </div>
</template>
<script>
import './scss/style.scss';
import Header from '@/components/Header.vue';

export default {
  components: {
    Header,
  },
  beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch('startUpdater');
    }
  },
};
</script>
